import { render, staticRenderFns } from "./add_platform.vue?vue&type=template&id=3b446e3c&scoped=true"
import script from "./add_platform.vue?vue&type=script&lang=js"
export * from "./add_platform.vue?vue&type=script&lang=js"
import style0 from "./add_platform.vue?vue&type=style&index=0&id=3b446e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b446e3c",
  null
  
)

export default component.exports